// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".text_b79 {\n  color: #1f2326;\n  color: var(--ring-text-color);\n}\n\n.info_5a9 {\n  color: #737577;\n  color: var(--ring-secondary-color);\n}\n", ""]);
// Exports
exports.locals = {
	"text": "text_b79",
	"info": "info_5a9"
};
module.exports = exports;
